<template>
  <div>
    <b-carousel
      id="carousel-1"
      v-model="slide"
      :interval="3000"
      :controls="controls"
      indicators
      :fade="fade"
      class="person-carousel"
    >
      <b-carousel-slide v-for="(item, index) in carouselData" :key="index">
        <b-row v-if="DataType == 0">
          <b-col
            class="person-carous"
            cols="12"
            md="6"
            v-for="(items, indexs) in item.data"
            :key="indexs"
          >
            <div class="home-six-person">
              <img :src="getImgUrl(items.avatar)" alt />
              <div class="home-six-text">
                <h6 class="maxLength-text-1">{{ items.nickname }}</h6>
                <p class="maxLength-text-1" v-if="items.info">
                  {{
                    items.info && items.info.jobExperiences
                      ? "经验" + items.info.jobExperiences
                      : ""
                  }}
                  {{ items.info.age ? " | " + items.info.age + "岁" : "" }}
                  {{ existData(items.info, "major", "") }}
                </p>
              </div>
              <a @click="preView(items.id)">
                <img src="@/assets/img/home/preview.png" alt />预览
              </a>
            </div>
          </b-col>
        </b-row>
        <!-- 合作伙伴 -->
        <b-row v-if="DataType == 1" class="partner">
          <b-col
            cols="6"
            md="3"
            v-for="(items, indexs) in item.data"
            :key="indexs"
          >
            <a @click="outSideLink(items.link)">
              <img :src="items.logoUrl" />
            </a>
          </b-col>
        </b-row>
        <!-- 已结束项目 -->
        <b-row class="wait-project" v-if="DataType == 2">
          <b-col
            cols="12"
            md="4"
            v-for="(item, index) in item.data"
            :key="index"
            @click="ProjectDetail(item.id)"
          >
            <img
              :src="getImgUrl(item.projectPhotoUrl)"
              @click="ProjectDetail(item.id)"
            />
            <div class="wait-content">
              <h5 class="maxLength-text-1">
                {{ item.name ? item.name : "" }}
              </h5>
              <div class="flex-text">
                <div class="projects-flex-text">
                  <span>项目类型</span>
                  <Category :categoryId="item.categoryId"></Category>
                </div>
                <div class="projects-flex-text">
                  <span>项目行业</span>
                  <p v-if="item.industry">{{ item.industry.name }}</p>
                </div>
                <div class="projects-flex-text">
                  <span>项目时长</span>
                  <p>{{ item.duration ? item.duration + "天" : "" }}</p>
                </div>
              </div>
              <p v-html="item.projectRequire" class="p-16-6 wait-desc"></p>
              <div
                class="projects-wait-footer"
                v-if="item.areas && item.areas.length > 0"
              >
                <i></i>
                <span>
                  {{ existData(item.areas[0], "provinceName", "") }}
                  {{
                    item.areas[0] && item.areas[0].cityName
                      ? existData(item.areas[0], "cityName", " - ")
                      : ""
                  }}
                </span>
              </div>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="DataType == 3">
          <b-col
            cols="12"
            md="4"
            v-for="(item, index) in item.data"
            :key="index"
          >
            <img :src="getImgUrl(item.picUrl)" />
            <div class="features">
              <div class="features-text">
                <h5>{{ item.name }}</h5>
                <a @click="toFeature(item.id)">
                  查看
                  <b-icon-arrow-right></b-icon-arrow-right>
                </a>
              </div>
            </div>
          </b-col>
        </b-row>
      </b-carousel-slide>
    </b-carousel>
  </div>
</template>

<script>
import Category from "@/components/category.vue";
import publicChange from "@/assets/js/index.js";
export default {
  name: "carousel",
  data() {
    return {
      slide: 0,
      sliding: null
    };
  },
  components: {
    Category
  },
  props: {
    carouselData: {
      type: Array
    },
    categoriesImgUr: {
      type: String
    },
    onChangeImgUr: {
      type: Function
    },
    preView: {
      type: Function
    },
    DataType: {
      type: Number,
      default: 0
    },
    controls: {
      type: Boolean,
      default: false
    },
    fade: {
      type: Boolean,
      default: false
    },
    indicators: {
      type: Boolean,
      default: true
    }
  },
  methods: {
    getImgUrl(img) {
      return publicChange.getStaticUrl(img);
    },
    // onSlideStart(slide) {
    //   this.sliding = true;
    //   console.log(slide);
    // },
    // onSlideEnd(slide) {
    //   this.sliding = false;
    //   console.log(slide);
    // }
    existData(data, index, text) {
      return publicChange.existData(data, index, text);
    },
    outSideLink(link) {
      window.location.href = link;
    },
    ProjectDetail(id) {
      const login = this.login();
      if (login) {
        this.$router.push({
          path: `/product/projectDetails`,
          query: {
            id: id
          }
        });
      } else {
        this.$router.push({
          path: "/login",
          query: {
            redirect: `/product/projectDetails?id=${id}`
          }
        });
        this.$message.warning("请先登录");
      }
    },
    toFeature(id) {
      this.$router.push({
        path: `/product`,
        query: {
          id: id
        }
      });
    },
    login() {
      return publicChange.userLogin();
    }
  }
};
</script>
<style lang="scss">
.img-height {
  position: relative;
  p {
    max-width: 600px;
  }
}
</style>
